import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Stack,
  Title,
  Text,
  List,
  ThemeIcon,
  Anchor,
} from "@mantine/core";
import { IconArrowLeft, IconCheck } from "@tabler/icons-react";

/**
 * Data migration documentation page.
 * Documents what we migrate: services, clients, employees, products, and appointments.
 */
export default function DataMigrationDocPage() {
  const navigate = useNavigate();

  return (
    <Stack p="xl" maw={720} mx="auto" gap="lg">
      <Button
        variant="subtle"
        leftSection={<IconArrowLeft size={16} />}
        onClick={() => navigate("/onboarding")}
      >
        Back to Onboarding
      </Button>
      <Title order={1}>Data Migration</Title>
      <Text c="dimmed" size="sm">
        We can help you bring your existing business data into Pagoda. Below is
        what we migrate.
      </Text>
      <List
        spacing="sm"
        size="sm"
        icon={
          <ThemeIcon size={24} radius="xl" color="teal">
            <IconCheck size={14} />
          </ThemeIcon>
        }
      >
        <List.Item>
          <strong>Services</strong> — Your service menu, pricing, durations, and
          settings
        </List.Item>
        <List.Item>
          <strong>Clients</strong> — Client profiles, contact info, and notes
        </List.Item>
        <List.Item>
          <strong>Employees</strong> — Staff accounts, roles, and permissions
        </List.Item>
        <List.Item>
          <strong>Products</strong> — Product catalog and inventory
        </List.Item>
        <List.Item>
          <strong>Appointments</strong> — Past and upcoming bookings
        </List.Item>
      </List>
      <Text size="sm">
        To get started with migration, email us at{" "}
        <Anchor href="mailto:contact@getpagoda.com" target="_blank">
          contact@getpagoda.com
        </Anchor>{" "}
        and we’ll guide you through the process.
      </Text>
    </Stack>
  );
}
